module.exports = __webpack_public_path__ + "static/media/4.55e88892.mp3";